export default __webpack_public_path__ + "static/network-pink-a4a5a8b9ee583b0ec0e800957f6fe71a.svg";